import { useParams } from 'react-router-dom'

import { Box, Button } from '@factorialco/deprecated-design-system'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface ValueActionsProps {
  valueId: number
  onDelete: (valueId: number) => void
  onEdit: (valueId: number) => void
}

const ValueActions = ({ valueId, onEdit, onDelete }: ValueActionsProps) => {
  const { id } = useParams()
  const { navigation } = useNavigation()

  return (
    <>
      <Box flexDirection="row" gap="s8" justifyContent="flexEnd">
        <PopoverMenu type="list">
          <PopoverMenu.Trigger>
            <Button.Decorative type="secondary" iconName="ellipsis" />
          </PopoverMenu.Trigger>
          <PopoverMenu.Content side="bottom" align="center">
            <PopoverMenu.TouchableOption
              title={i18n.t('finance.dimension_detail.options.edit_details')}
              onClick={() => onEdit(valueId)}
            />
            <PopoverMenu.TouchableOption
              title={i18n.t('finance.dimension_detail.options.delete')}
              danger
              onClick={() => onDelete(valueId)}
            />
          </PopoverMenu.Content>
        </PopoverMenu>

        <Button.Router
          to={navigation.settings.finance.dimensions.dimension.values.fullPath({
            id: id!,
            value_id: valueId,
          })}
          type="secondary"
          iconName="arrow-right"
        />
      </Box>
    </>
  )
}

export default ValueActions
